import React from 'react';


import component, {classnames} from '../component';
import HtmlContent from '../HtmlContent';
import TopBanner from '../TopBanner';
import {HBox, VBox} from '../Box';
import {ArrowUp, Mail} from '../icons';

const FaqItem = component('FaqItem', function({data}) {
  const expandItem = () => {
    data.setIn('expanded', !(data.get('expanded') || false));
  };

  const itemCls = {
    'Faq-Item': true,
    'Faq-Item--Expanded': data.get('expanded')
  };

  const Answer = component('Answer', function({text}) {
    return <HtmlContent className="Faq-ItemText" html={text} />
  });

  return (
    <li className={classnames(itemCls)}>
      <div className="Faq-ItemTitle">
        <span onClick={expandItem} className="Faq-ItemTitleText">{data.get('question')}</span>
        <ArrowUp onClick={expandItem} className='Faq-Arrow' />
      </div>
      {
        data.get('expanded')
        &&
        <Answer text={data.get('answer')} />
      }
    </li>
  )
});

export default component('Faq', function({data}) {
  return (
    <div>
      <TopBanner size='tiny' />
      <HBox width={4}>
        <div className="Faq">
          <div className="Faq-Content">
            <h1 className="Faq-Title">F.A.Q</h1>
            <div className="Faq-Caption">
              Основные вопросы по взаимодействию с турнирной платформой.
            </div>
            {data.getIn('faq') &&
              <ul className="Faq-List">
                {data.cursor('faq').map((item, idx)=>(<FaqItem key={idx} data={item} />))}
              </ul>
            }
          </div>
          <div className="Faq-Mail">
            <Mail className="Faq-MailIcon" />
            Если у тебя все еще остались вопросы, ты можешь задать их через службу поддержки - <a href="https://ru.4gamesupport.com" target="_blank">https://ru.4gamesupport.com</a>
          </div>
        </div>
      </HBox>
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/pages/Faq.js